import { FC, ReactNode, useMemo } from "react";
import { IconButton } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

import { StyledModal, StyledModalContainer } from "styles/components/modals";

interface ModalProps {
  open: boolean;
  children?: ReactNode;
  withCloseBtn?: boolean;
  dataTestId?: string;

  onClose?: () => void;
}

const Modal: FC<ModalProps> = ({
  open,
  children,
  withCloseBtn,
  dataTestId,
  onClose,
}) => {
  const renderedBackButton = useMemo(
    () =>
      withCloseBtn && (
        <IconButton
          className="modal-close"
          data-testid={dataTestId && `${dataTestId}-close`}
          onClick={onClose}
        >
          <CloseOutlinedIcon />
        </IconButton>
      ),
    [dataTestId, onClose, withCloseBtn]
  );

  return (
    <StyledModal open={open} onClose={onClose} data-testid={dataTestId}>
      <StyledModalContainer
        data-testid={dataTestId && `${dataTestId}-container`}
      >
        {renderedBackButton}
        {children}
      </StyledModalContainer>
    </StyledModal>
  );
};

export default Modal;
